import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useForgotPassword } from "../../Controllers/AuthController";
import EmailInput from "../../Components/Inputs/EmailInput";
import ContainedButton from "../../Components/Buttons/ContainedButton";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const { control, formState, handleSubmit } = useForm({
    mode: "onChange",
    defaultValues: {
      email: "",
    },
  });

  const { isValid, errors } = formState;
  const { mutateAsync: forgotPassword, isPending: isSubmitting } =
    useForgotPassword();

  const onSubmit = async (data) => {
    try {


      await forgotPassword({ email: data.email });


      toast.success("Reset Link Sent Successfully!");
      navigate("/forgot-password/email-sent");
    } catch (error) {
      console.error("Forgot password error:", error);
      toast.error(
        error?.response?.data?.message ||
          "Something went wrong. Please try again.",
      );
    }
  };

  return (
    <div className="onboarding-container">
      <div className="onboard-content flex-grow-1">
        <div className="admin-sign-in">
          <h4
            style={{
              textAlign: "center",
              color: "rgba(230, 236, 241, 1)",
              fontFamily: "Poppins",
              fontSize: "20px",
              lineHeight: "30px",
              fontWeight: 600,
            }}
          >
            Forgot Password?
          </h4>
          <h4
            style={{
              marginBottom: "40px",
              textAlign: "center",
              color: "rgba(230, 236, 241, 1)",
              fontFamily: "Poppins",
              fontSize: "16px",
              lineHeight: "30px",
              fontWeight: 300,
            }}
          >
            We will send you a link on your email to reset password
          </h4>

          <form
            onSubmit={handleSubmit(onSubmit)}
            className="d-flex flex-column align-items-center"
          >
            <div className="gap-3 gap-sm-4 d-flex flex-column align-items-center w-100">
              <div className="textfield-1 input-fields w-100">
                <EmailInput
                  name="email"
                  control={control}
                  label="Enter email"
                  placeholder=" "
                  rules={{
                    required: "Email is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Invalid email address",
                    },
                  }}
                  className={`text-body-b2 w-100 ${errors.email ? "error" : ""}`}
                />
                {errors.email && (
                  <p className="text-danger small mt-1">
                    {errors.email.message}
                  </p>
                )}
              </div>
            </div>

            <div
              className="d-flex flex-column flex-sm-row gap-3 gap-sm-4 terms-buttons align-items-center w-100"
              style={{ maxWidth: "345px", marginTop: "40px" }}
            >
              <ContainedButton
                onClick={() => navigate("/login")}
                className="btn-1 btn-1-basic"
                style={{ maxWidth: "160px", width: "100%" }}
              >
                Back
              </ContainedButton>
              <ContainedButton
                type="submit"
                isFormValid={isValid}
                isLoading={isSubmitting}
                style={{
                  backgroundColor: isSubmitting
                    ? "rgba(153, 209, 255, 1)"
                    : isValid
                      ? "rgba(0, 140, 255, 1)"
                      : "rgba(153, 209, 255, 1)",
                  color: "rgba(230, 236, 241, 1)",
                  border: "1.5px solid rgba(0, 140, 255, 1)",
                  borderRadius: "24px",
                  padding: "6px 32px",
                  width: "100%",
                  height: "52px",
                  fontWeight: 600,
                  fontSize: "16px",
                  lineHeight: "24px",
                  cursor: isValid || isSubmitting ? "pointer" : "not-allowed",
                }}
              >
                {isSubmitting ? "Sending..." : "Send"}
              </ContainedButton>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
